"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductInstallmentsCrossStep = void 0;

var _tabs = require("@creditas-lab/tabs");

var _services = require("../../services");

var _hooks = require("../../hooks");

var _constants = require("../../constants");

var _mocks = require("../../mocks");

const getTabByProductsRanges = intendedCredit => {
  var _Object$entries$find;

  const [productName] = (_Object$entries$find = Object.entries(_mocks.CreditRangeByProduct).find(([, {
    min,
    max
  }]) => {
    return intendedCredit >= min && intendedCredit <= max;
  })) != null ? _Object$entries$find : [];
  return productName != null ? productName : _constants.ProductTypes.HOME;
};

const tabChangeEvents = {
  [_constants.TabsPosition[_constants.ProductTypes.HOME]]: _services.dispatchHomeTabChangeEvent,
  [_constants.TabsPosition[_constants.ProductTypes.AUTO]]: _services.dispatchAutoTabChangeEvent
};

const useProductInstallmentsCrossStep = () => {
  const {
    intendedCredit
  } = (0, _hooks.useSimulator)();
  const tabByProductRange = getTabByProductsRanges(intendedCredit);
  const tabs = (0, _tabs.useTabState)(_constants.TabsPosition[tabByProductRange]);

  const onTabChange = currentTabIndex => {
    const tabChangeEvent = tabChangeEvents[currentTabIndex];
    tabChangeEvent();
  };

  return {
    tabs,
    onTabChange
  };
};

exports.useProductInstallmentsCrossStep = useProductInstallmentsCrossStep;